import React, { useState } from "react";
import { Plus, Minus } from "lucide-react";
import { faqs } from "../mock";

import { tr } from "../i18n";
export default function FAQ() {
  const [open, setOpen] = useState(0);

  return (
    <section className="bg-[#f6f2e9] py-20 md:py-28 relative overflow-hidden">
      {/* art deco fan pattern */}
      <div className="pointer-events-none absolute -bottom-32 -right-32 w-96 h-96 opacity-[0.06]">
        <div className="absolute inset-0 rounded-full border-[16px] border-[#0b1f3a]" />
        <div className="absolute inset-8 rounded-full border-[12px] border-[#0b1f3a]" />
        <div className="absolute inset-16 rounded-full border-[8px] border-[#0b1f3a]" />
      </div>

      <div className="max-w-3xl mx-auto px-5 md:px-8 relative z-10">
        <div className="text-center mb-12 reveal">
          <div className="deco-line w-24 mx-auto mb-6" />
          <h2 className="font-display text-[34px] md:text-[46px] text-[#0b1f3a]">
            {tr("Commonly asked questions")}
          </h2>
        </div>

        <div className="space-y-3">
          {faqs.map((f, i) => {
            const isOpen = open === i;
            return (
              <div
                key={i}
                className="rounded-xl bg-white ring-1 ring-[#0b1f3a]/8 overflow-hidden"
              >
                <button
                  onClick={() => setOpen(isOpen ? -1 : i)}
                  className="w-full flex items-center justify-between gap-4 text-left px-6 py-5"
                >
                  <span className="font-medium text-[#0b1f3a] text-[16px] md:text-[18px]">
                    {f.q}
                  </span>
                  <span className="shrink-0 w-8 h-8 rounded-full bg-[#f6f2e9] flex items-center justify-center text-[#c2a15a]">
                    {isOpen ? <Minus size={18} /> : <Plus size={18} />}
                  </span>
                </button>
                <div
                  className="grid transition-all duration-300 ease-out"
                  style={{
                    gridTemplateRows: isOpen ? "1fr" : "0fr",
                  }}
                >
                  <div className="overflow-hidden">
                    <p className="px-6 pb-6 text-[#0b1f3a]/65 text-[15px] leading-relaxed">
                      {f.a}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
